var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19.75C3.27208 19.75 0.25 16.7279 0.25 13L0.249999 5C0.249999 2.37665 2.37665 0.25 5 0.25C7.62335 0.25 9.75 2.37665 9.75 5L9.75 13.1429C9.75 14.6616 8.51878 15.8929 7 15.8929C5.48122 15.8929 4.25 14.6616 4.25 13.1429L4.25 5.28571C4.25 4.8715 4.58579 4.53571 5 4.53571C5.41421 4.53571 5.75 4.8715 5.75 5.28571L5.75 13.1429C5.75 13.8332 6.30964 14.3929 7 14.3929C7.69036 14.3929 8.25 13.8332 8.25 13.1429L8.25 5C8.25 3.20507 6.79492 1.75 5 1.75C3.20507 1.75 1.75 3.20507 1.75 5L1.75 13C1.75 15.8995 4.10051 18.25 7 18.25C9.8995 18.25 12.25 15.8995 12.25 13L12.25 5.28571C12.25 4.8715 12.5858 4.53571 13 4.53571C13.4142 4.53571 13.75 4.8715 13.75 5.28571L13.75 13C13.75 16.7279 10.7279 19.75 7 19.75Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAttachment);
export default __webpack_public_path__ + "static/media/ico-attachment.2d02ea21d6b8e75b2b62cfe84f4d257b.svg";
export { ForwardRef as ReactComponent };